import {AnyEvent, TEAM_CLEARED_EVENT} from '../type';

export default function teamCleared(): AnyEvent {
  return {
    type: TEAM_CLEARED_EVENT
  }
}